import _classPrivateFieldInitSpec from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _handlers = /*#__PURE__*/new WeakMap();
/* eslint-disable @typescript-eslint/ban-types */
/**
 * 组件全局变量
 * @class GlobalEvent
 */
class GlobalEvent {
  constructor() {
    _defineProperty(this, "globalVal", {});
    _classPrivateFieldInitSpec(this, _handlers, {});
  }
  /**
   * 提供全局变量
   * @param key 键
   * @param val 值
   */
  provide(key, val) {
    this.globalVal[key] = val;
    this.publish(key, val);
  }
  /**
   * 发布者
   * @param key 事件名称
   * @param val 值
   */
  publish(key, val) {
    if (_classPrivateFieldGet(_handlers, this)[key]) {
      _classPrivateFieldGet(_handlers, this)[key].forEach(handler => {
        handler(val);
      });
    }
  }
  /**
   * 订阅者
   * @param key 事件名称
   * @param handler 值
   */
  subscribe(key, handler) {
    if (!_classPrivateFieldGet(_handlers, this)[key]) {
      _classPrivateFieldGet(_handlers, this)[key] = [];
    }
    _classPrivateFieldGet(_handlers, this)[key].push(handler);
  }
}
const global = new GlobalEvent();
export default global;